import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [
    {
      id: "summary-log-ap-offline",
      severity: 2,
      createdAt: 1787029200000,
      siteId: "site-1",
      siteName: "Taipei Site",
      accountId: "account-1",
      accountName: "Ivan",
      orgId: "org-1",
      orgName: "D-Link",
      eventType: "DEVICE_OFFLINE",
      deviceName: "AP-Lobby-01",
      deviceMacAddress: "00:11:22:33:44:55",
      deviceType: "ap",
      payload: { translationKey: "ap_offline" },
      acknowledge: false,
      mspId: "msp-1",
      mspName: "D-Link MSP",
      deviceId: "ap-lobby-01",
    },
    {
      id: "summary-log-port-error",
      severity: 4,
      createdAt: 1787025600000,
      siteId: "site-1",
      siteName: "Taipei Site",
      accountId: "account-1",
      accountName: "Ivan",
      orgId: "org-1",
      orgName: "D-Link",
      eventType: "CL_EVENT_SW_PORT_ERROR",
      deviceName: "SW-Core-01",
      deviceMacAddress: "00:11:22:33:44:66",
      deviceType: "switch",
      payload: { translationKey: "sw_port_error", portNum: 5, errorType: 1 },
      acknowledge: false,
      mspId: "msp-1",
      mspName: "D-Link MSP",
      deviceId: "sw-core-01",
    },
    {
      id: "summary-log-ap-online",
      severity: 6,
      createdAt: 1787022000000,
      siteId: "site-1",
      siteName: "Taipei Site",
      accountId: "account-1",
      accountName: "Ivan",
      orgId: "org-1",
      orgName: "D-Link",
      eventType: "DEVICE_ONLINE",
      deviceName: "AP-Meeting-02",
      deviceMacAddress: "00:11:22:33:44:77",
      deviceType: "ap",
      payload: { translationKey: "ap_online" },
      acknowledge: true,
      mspId: "msp-1",
      mspName: "D-Link MSP",
      deviceId: "ap-meeting-02",
    },
  ],
};

const summaryReportLogsSlice = createSlice({ name: "summaryReportLogs", initialState });

export default summaryReportLogsSlice.reducer;
